import React, { useState } from "react";
import withRouter from "../../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useMutation } from "react-query";
import { authUser } from "../services/authApi";
import "../../../assets/login_page_assets/css/login.css";
import check from "../../../assets/login_page_assets/images/check.png";
import loginImage from "../../../assets/login_page_assets/images/login.jpg";
import { Button, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { Alert } from "antd";
import '../../Styles/style.css'
import { useNavigate } from "react-router-dom";

const Login = (props) => {
  const navigate = useNavigate();
  document.title = `Connexion | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [error, setError] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);

  const { isLoading, mutate } = useMutation(authUser, {
    onSuccess: (data) => {
      if (data?.isAuthorized) {
        props.router.navigate("/dashboard");
      } else {
        setError("Nom d'utilisateur ou mot de passe incorrect !");
        sessionStorage.clear();
      }
    },
    onError: (error) => {
      setError(error);
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Identifiant incorrect!"),
      password: Yup.string().required("Mot de passe incorrect!"),
    }),
    onSubmit: (values) => {
      const formData = {
        username: values.username,
        password: values.password,
      };
      mutate(formData);
    },
  });

  return (
    <div className="mybox">
      <div className="left-box">
        <div className="left-children">
          <div className="left-logo-box">
            <img src={check} alt="Logo" className="imagelogingauche"/>
          </div>
          {error && <Alert message={error} type="error" showIcon />}
          <Form onSubmit={validation.handleSubmit}>
            <div className="mb-4">
              <Label htmlFor="username" className="text-white">Adresse email</Label>
              <Input
                name="username"
                id="username"
                className="form-control pe-5 login-fc"
                placeholder="Entrer votre adresse email"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.username}
                invalid={
                  validation.touched.username && validation.errors.username
                }
              />
              <FormFeedback>{validation.errors.username}</FormFeedback>
            </div>
            <div className="mb-3">
              <Label className="text-white form-label" htmlFor="password-input">
                {" "}
                Mot de Passe{" "}
              </Label>
              <div className="position-relative auth-pass-inputgroup mb-3">
                <Input
                  autoComplete="on"
                  name="password"
                  id="password-input"
                  value={validation.values.password || ""}
                  type={passwordShow ? "text" : "password"}
                  className="form-control pe-5 login-fc"
                  placeholder="Entrer le mot de passe"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    !!(
                      validation.touched.password && validation.errors.password
                    )
                  }
                />
                {validation.touched.password && validation.errors.password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.password}
                  </FormFeedback>
                ) : null}
                <button
                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                  type="button"
                  id="password-addon"
                  onClick={() => setPasswordShow(!passwordShow)}
                >
                  <i className="ri-eye-fill align-middle fs-18"></i>
                </button>
              </div>
              <span className="mt-3" style={{ textAlign: "right", cursor: "pointer", color: "#ffffff", textDecoration: "underline" }}
                  title="Réinitialisation de mot de passe"
                  onClick={() => navigate("/update-password")}
                >
                Mot de passe oublié ?
              </span>
            </div>
            <Button
              disabled={!(validation.isValid && validation.dirty)}
              type="submit"
              className="active-tab form-control pe-5 login-fc"
            >
              {isLoading ? <Spinner size="sm" /> : "Se connecter"}
            </Button>
          </Form>            
        </div>
      </div>
      <div className="rigth-box">
            <div className="overlay-text">
              <h1 color="#fff">Avec Check-auto</h1><br/>
              <h2>La performance de votre vehicule, notre priorité !</h2><br/>
              <h3>Surveillez chaque véhicule pour optimiser ses performances et garantir sa sécurité.</h3>
            </div>
          <img src={loginImage} alt="" className="right-img" />
      </div>
    </div>
  );
};

export default withRouter(Login);
